import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackUserChatsSelect } from './trackUserChatsSelect';
import { subAgentsSelector } from '../../selectors';

export const useSubAgentSelectTracking = (): ((selectedSubAgentId: number) => void) => {
  const { subAgentsList } = useSelector(subAgentsSelector);

  return React.useCallback(
    (selectedSubAgentId: number) => {
      const selectedSubAgent = subAgentsList.find(subAgent => subAgent.userId === selectedSubAgentId);
      const position = subAgentsList.findIndex(subAgent => subAgent.userId === selectedSubAgentId) + 1;

      trackUserChatsSelect({
        userId: selectedSubAgentId as number,
        unreadCount: selectedSubAgent?.totalUnreadMessagesCount || 0,
        position,
        isMine: false,
      });
    },
    [subAgentsList],
  );
};
